module.exports = __webpack_public_path__ + "img/category-new-released.2ca41122.png";